var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 186,
    viewBox: "0 0 184 186",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 184,
    height: 186
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.1788 45.3787L101.135 28.6695L120.57 60.6809L109.489 69.739L75.4554 59.3617L70.1788 45.3787Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.8595 37.8156L78.7092 27.1745L59.4496 5.2766L55.1404 35.5291L68.8595 37.8156Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.135 28.6695L78.7092 27.1745L68.8595 37.8156L70.1788 45.3787L101.135 28.6695Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6497 52.2383L70.1788 45.3787L68.8595 37.8156L55.1404 35.5291L34.6497 52.2383Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5361 27.7021L85.5688 22.0738L76.4227 12.9277L59.4496 5.2766L78.7092 27.1745L86.5361 27.7021Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.271 25.1518L116.613 17.5007L92.2525 0L76.4227 12.9277L85.5688 22.0738L113.271 25.1518Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.1915 12.3121L92.2525 0L76.4227 12.9277L75.1915 12.3121Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.57 60.6809L129.189 55.844L127.694 41.5972L101.135 28.6695L120.57 60.6809Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.996 61.8241L160.848 34.4738L127.694 41.5972L129.189 55.844L142.996 61.8241Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.967 40.1901L134.817 36.2326L148.36 34.034L160.848 34.4738L127.694 41.5972L124.967 40.1901Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5361 27.7021L85.5688 22.0738L113.271 25.1518L134.817 36.2326L124.967 40.1901L101.135 28.6695L86.5361 27.7021Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.613 17.5007L147.745 15.7418L148.36 34.034L134.817 36.2326L113.271 25.1518L116.613 17.5007Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.989 34.2979L147.745 15.7418L148.36 34.034L153.989 34.2979Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.875 86.0085L142.996 61.8241L129.189 55.844L120.57 60.6809L143.875 86.0085Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.848 34.4738L162.167 52.5901L156.011 64.4624L143.26 70.8823L142.996 61.8241L160.848 34.4738Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.311 91.7248L172.809 92.2525L183.274 62.3518L162.167 52.5901L156.011 64.4624L163.311 91.7248Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.816 47.4894L183.274 62.3518L162.167 52.5901L161.816 47.4894Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4554 59.3617L70.1788 45.3787L34.6497 52.2383L39.8383 87.8553H55.0525L75.4554 59.3617Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5574 36.8482L53.2936 33.5943L55.1404 21.1064L59.4496 5.2766L55.1404 35.5291L53.5574 36.8482Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5574 36.8482L53.2936 33.5943L34.6497 51.9745L53.5574 36.8482Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8383 87.8553L32.6269 88.9106L26.383 77.1262L34.6497 52.2383L39.8383 87.8553Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90.4057L26.383 77.1262L27.3504 74.3121L23.9206 75.3674L13.0156 80.8199L0 90.4057Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6043 48.5447L6.85962 66.661L13.0156 80.8199L23.9206 75.3674L34.6497 51.9745L30.6043 48.5447Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6497 51.9745L53.2936 33.5943L55.1404 21.1064L38.9589 19.6993L30.6043 48.5447L34.6497 51.9745Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.844 18.4681L38.9589 19.6993L55.1404 21.1064L55.844 18.4681Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 80.8199L6.85962 66.661L11.6086 81.8752L13.0156 80.8199Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90.4057L26.383 101.662L32.6269 88.9106L26.383 77.1262L0 90.4057Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8383 87.8553L34.6496 122.241L26.383 101.662L32.6269 88.9106L39.8383 87.8553Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 90.4057L13.0156 103.421L24.4482 108.962H29.3731L26.383 101.662L0 90.4057Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0525 87.8553L75.4554 59.3617L109.489 69.739L109.489 105.972L75.4553 116.789L55.0525 87.8553Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.875 86.0085L120.57 113.711L109.489 105.972L109.489 69.739L120.57 60.6809L143.875 86.0085Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6496 122.241L39.8383 87.8553H55.0525L75.4553 116.789L70.1787 130.332L34.6496 122.241Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.489 105.972L120.57 113.711L101.135 144.403L70.1787 130.332L75.4553 116.789L109.489 105.972Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.875 86.0085L142.82 114.238L129.277 120.043L120.57 113.711L143.875 86.0085Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.1787 130.332L68.5958 139.566L55.0525 142.292L34.6496 122.241L70.1787 130.332Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.135 144.403L70.1787 130.332L68.5958 139.566L79.1489 150.559L101.135 144.403Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0525 142.292L59.2737 174.479L79.1489 150.559L68.5958 139.566L55.0525 142.292Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4156 148.184L85.5688 161.2L76.5107 170.61L59.2737 174.479L79.1489 150.559L87.4156 148.184Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0525 142.292L53.1178 140.445V149.855L55.0525 162.783L59.2737 174.479L55.0525 142.292Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3731 108.962H24.4482L36.0568 133.322L53.1178 149.855V140.445L34.6496 122.241L29.3731 108.962Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 103.421L24.4482 108.962L36.0568 133.322L30.5164 138.599L6.4199 121.626L13.0156 103.421Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0525 162.783L38.7829 167.356L30.5164 138.599L36.0568 133.322L53.1178 149.855L55.0525 162.783Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.7234 167.356H38.7829L55.0525 162.783L56.7234 167.356Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.311 91.7248L156.011 64.4624L143.26 70.8823L143.875 86.0085L143.26 106.851L156.011 116.789L163.311 91.7248Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.167 129.189L183.274 121.538L172.809 92.2525L163.311 91.7248L156.011 116.789L162.167 129.189Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.26 106.851L156.011 116.789L162.167 129.189L160.936 142.996L142.82 114.238L143.26 106.851Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.274 121.538L161.464 137.104L162.167 129.189L183.274 121.538Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.277 120.043L142.82 114.238L160.936 142.996L127.87 134.905L129.277 120.043Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.135 144.403L120.57 113.711L129.277 120.043L127.87 134.905L101.135 144.403Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.936 142.996L148.448 148.184L134.817 145.546L121.626 137.104L127.87 134.905L160.936 142.996Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.5107 170.61L85.5688 161.2L113.799 159.705L116.789 167.972L91.9886 186L76.5107 170.61Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.4156 148.184L101.135 144.403L121.626 137.104L134.817 145.546L113.799 159.705L85.5688 161.2L87.4156 148.184Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.3447 171.313L91.9886 186L76.5107 170.61L73.3447 171.313Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.817 145.546L148.448 148.184L147.657 169.379L116.789 167.972L113.799 159.705L134.817 145.546Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.011 145.018L147.657 169.379L148.448 148.184L156.011 145.018Z",
    fill: "#A4A4A4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9206 75.3674L34.6497 51.9745L27.3504 74.3121L23.9206 75.3674Z",
    fill: "#A4A4A4"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.1787 45.3787L101.135 28.6695L120.57 60.6808L109.489 69.739L75.4553 59.3617L70.1787 45.3787Z",
    fill: "#767676"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8595 37.8156L78.7092 27.1745L59.4496 5.27661L55.1404 35.5291L68.8595 37.8156Z",
    fill: "#B8B9B5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M101.135 28.6695L78.7093 27.1744L68.8596 37.8156L70.1788 45.3787L101.135 28.6695Z",
    fill: "#B1B1B1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6497 52.2383L70.1787 45.3787L68.8596 37.8156L55.1404 35.5291L34.6497 52.2383Z",
    fill: "#E3E0DB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5361 27.7021L85.5687 22.0738L76.4226 12.9277L59.4496 5.27661L78.7092 27.1745L86.5361 27.7021Z",
    fill: "#FAF9F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.271 25.1518L116.613 17.5007L92.2525 0L76.4227 12.9277L85.5688 22.0738L113.271 25.1518Z",
    fill: "#ECEBE4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1915 12.3121L92.2525 0L76.4227 12.9277L75.1915 12.3121Z",
    fill: "#B2B1B2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M120.57 60.6808L129.189 55.844L127.694 41.5972L101.135 28.6695L120.57 60.6808Z",
    fill: "#ECEBE4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M142.996 61.8241L160.848 34.4738L127.694 41.5972L129.189 55.844L142.996 61.8241Z",
    fill: "#D1D0C8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M124.967 40.1901L134.817 36.2326L148.36 34.0341L160.848 34.4738L127.694 41.5972L124.967 40.1901Z",
    fill: "#DAD9D3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5362 27.7022L85.5688 22.0738L113.271 25.1518L134.817 36.2327L124.967 40.1901L101.135 28.6695L86.5362 27.7022Z",
    fill: "#F2F1EA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M116.613 17.5007L147.745 15.7418L148.36 34.034L134.817 36.2326L113.271 25.1518L116.613 17.5007Z",
    fill: "#D4D5CE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M153.989 34.2978L147.745 15.7418L148.36 34.034L153.989 34.2978Z",
    fill: "#F1F1E7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M143.875 86.0085L142.996 61.8241L129.189 55.844L120.57 60.6809L143.875 86.0085Z",
    fill: "#F0F0E8"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M160.848 34.4738L162.167 52.5901L156.011 64.4624L143.26 70.8823L142.996 61.8241L160.848 34.4738Z",
    fill: "#CBCBBF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.311 91.7248L172.809 92.2525L183.274 62.3518L162.167 52.5901L156.011 64.4624L163.311 91.7248Z",
    fill: "#C8C7BE"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M161.816 47.4894L183.274 62.3518L162.167 52.5901L161.816 47.4894Z",
    fill: "#F4F4EC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.4553 59.3617L70.1787 45.3787L34.6497 52.2383L39.8383 87.8553H55.0525L75.4553 59.3617Z",
    fill: "#999895"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5574 36.8482L53.2936 33.5943L55.1404 21.1064L59.4496 5.27661L55.1404 35.5291L53.5574 36.8482Z",
    fill: "#8F8F8F"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5575 36.8482L53.2936 33.5943L34.6497 51.9744L53.5575 36.8482Z",
    fill: "#A2A2A1"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8383 87.8553L32.6269 88.9106L26.3829 77.1262L34.6496 52.2383L39.8383 87.8553Z",
    fill: "#838383"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.4057L26.383 77.1263L27.3504 74.3121L23.9206 75.3674L13.0156 80.8199L0 90.4057Z",
    fill: "#B1B1B1"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6043 48.5447L6.85962 66.661L13.0156 80.8199L23.9206 75.3674L34.6497 51.9745L30.6043 48.5447Z",
    fill: "#ACACAC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6496 51.9745L53.2936 33.5943L55.1404 21.1064L38.9589 19.6993L30.6042 48.5447L34.6496 51.9745Z",
    fill: "#989898"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M55.844 18.4681L38.9589 19.6993L55.1404 21.1064L55.844 18.4681Z",
    fill: "#E1E2DC"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0156 80.8199L6.85962 66.661L11.6086 81.8752L13.0156 80.8199Z",
    fill: "#787777"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.4057L26.383 101.662L32.6269 88.9106L26.383 77.1262L0 90.4057Z",
    fill: "#959595"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8383 87.8553L34.6496 122.241L26.3829 101.662L32.6269 88.9107L39.8383 87.8553Z",
    fill: "#A1A1A1"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 90.4057L13.0156 103.421L24.4482 108.962H29.3731L26.383 101.662L0 90.4057Z",
    fill: "#454545"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0525 87.8553L75.4553 59.3617L109.489 69.739V105.972L75.4553 116.789L55.0525 87.8553Z",
    fill: "#A1A19F"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M143.875 86.0085L120.57 113.711L109.489 105.972V69.739L120.57 60.6808L143.875 86.0085Z",
    fill: "#949494"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6497 122.241L39.8383 87.8553H55.0525L75.4553 116.789L70.1787 130.332L34.6497 122.241Z",
    fill: "#DBDAD2"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M109.489 105.972L120.57 113.711L101.135 144.403L70.1787 130.332L75.4553 116.789L109.489 105.972Z",
    fill: "#BDBEBA"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M143.875 86.0085L142.82 114.238L129.277 120.043L120.57 113.711L143.875 86.0085Z",
    fill: "#848480"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M70.1787 130.332L68.5958 139.566L55.0525 142.292L34.6497 122.241L70.1787 130.332Z",
    fill: "#595959"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M101.135 144.403L70.1787 130.332L68.5957 139.566L79.1489 150.559L101.135 144.403Z",
    fill: "#6A6A6A"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0525 142.292L59.2738 174.479L79.1489 150.559L68.5958 139.566L55.0525 142.292Z",
    fill: "#828282"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4156 148.184L85.5688 161.2L76.5107 170.61L59.2738 174.479L79.149 150.559L87.4156 148.184Z",
    fill: "#515151"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0525 142.292L53.1178 140.445V149.855L55.0525 162.783L59.2738 174.479L55.0525 142.292Z",
    fill: "#7C7C7C"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3731 108.962H24.4482L36.0568 133.322L53.1177 149.855V140.445L34.6497 122.241L29.3731 108.962Z",
    fill: "#6C6C6C"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0157 103.421L24.4483 108.962L36.0568 133.322L30.5164 138.599L6.41992 121.626L13.0157 103.421Z",
    fill: "#656565"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0524 162.783L38.7829 167.356L30.5162 138.599L36.0567 133.322L53.1177 149.855L55.0524 162.783Z",
    fill: "#818181"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7234 167.356H38.783L55.0525 162.783L56.7234 167.356Z",
    fill: "#373738"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M163.311 91.7248L156.011 64.4624L143.26 70.8823L143.875 86.0085L143.26 106.851L156.011 116.789L163.311 91.7248Z",
    fill: "#EAE9DF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.167 129.189L183.274 121.538L172.809 92.2525L163.311 91.7249L156.011 116.789L162.167 129.189Z",
    fill: "#E6E6DC"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M143.26 106.851L156.011 116.789L162.167 129.189L160.936 142.996L142.82 114.238L143.26 106.851Z",
    fill: "#FAF9EF"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M183.274 121.538L161.464 137.104L162.167 129.189L183.274 121.538Z",
    fill: "#85837B"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M129.277 120.043L142.82 114.238L160.936 142.996L127.87 134.905L129.277 120.043Z",
    fill: "#B0AFA9"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M101.135 144.403L120.57 113.711L129.277 120.043L127.87 134.905L101.135 144.403Z",
    fill: "#DEDED4"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M160.936 142.996L148.448 148.184L134.817 145.546L121.626 137.104L127.87 134.905L160.936 142.996Z",
    fill: "#343434"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5106 170.61L85.5688 161.2L113.799 159.705L116.789 167.972L91.9886 186L76.5106 170.61Z",
    fill: "#686866"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M87.4157 148.184L101.135 144.403L121.626 137.104L134.817 145.546L113.799 159.705L85.5688 161.2L87.4157 148.184Z",
    fill: "#464646"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M73.3447 171.313L91.9887 186L76.5107 170.61L73.3447 171.313Z",
    fill: "#484849"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M134.817 145.546L148.448 148.184L147.657 169.379L116.789 167.972L113.799 159.705L134.817 145.546Z",
    fill: "#5A5A5A"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M156.011 145.018L147.657 169.379L148.448 148.184L156.011 145.018Z",
    fill: "#D9DACE"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9205 75.3674L34.6496 51.9745L27.3503 74.3121L23.9205 75.3674Z",
    fill: "#A4A4A4"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 183,
    height: 186,
    fill: "#043D8F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel5);
export default __webpack_public_path__ + "static/media/level5.e9b0b62542f4711cb8acaa5fa4b0179d.svg";
export { ForwardRef as ReactComponent };